import dotenv from 'dotenv'
dotenv.config();
export const API_URL =process.env.VUE_APP_URL // 'http://localhost:8000/api'//process.env.VUE_APP_URL;
export default API_URL;